import { IconPack } from '../types';

const loaders = {
  default: () => import('./default'),
  thin: () => import('./thin'),
} as const;

export async function loadIconSet(setName: IconPack) {
  const loader = loaders[setName as keyof typeof loaders];

  if (!loader) {
    throw new Error(`Unknown icon set: ${setName}`);
  }

  return loader();
}